export async function storeproviders() {
  const {
    LangProvider,
    ThemeProvider,
    TokenProvider,
    AlertProvider,
    FcmProvider,
  } = await import('./store');

  return [
    LangProvider,
    ThemeProvider,
    TokenProvider,
    AlertProvider,
    FcmProvider,
  ];
}
